/**
 * @file 投放优化
 * @author lanistzhang
 */

import _ from 'lodash';
import React from 'react';
import { Button } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import globalStore from '@/stores';
import HomeItem from '../home-item';
import TopList, { TopListType } from './TopList';

import './index.scoped.less';

const Advertising: React.FC<any> = (props) => {
  const { title } = props;
  const { history } = globalStore;
  return <HomeItem
    header={(
      <>
        <div className="title">{title}</div>
        <div className="right">
        <Button
          className="more"
          displayType="link"
          endIcon={<Icon name="right-outlined"/>}
          data-report="home-jump-advertising-more"
          onClick={() => history.push('/agency/advertising/tencent')}
        >
          更多
        </Button>
        </div>
      </>
    )}
  >
    <div className='advertising-cont'>
      <div className='row'>
        <div className='item'>
          <TopList type={TopListType.mdm_cost} />
        </div>
        <div className='item'>
          <TopList type={TopListType.industry_cost} />
        </div>
      </div>
      <div className='row'>
        <div className='item'>
          <TopList type={TopListType.uid_cost} />
        </div>
        <div className='item'>
          <TopList type={TopListType.mdm_increase} />
        </div>
      </div>
    </div>
  </HomeItem>;
};

export default Advertising;
